import { render, staticRenderFns } from "./ProfileStyle.vue?vue&type=template&id=39964182&scoped=true"
import script from "./ProfileStyle.vue?vue&type=script&lang=js"
export * from "./ProfileStyle.vue?vue&type=script&lang=js"
import style0 from "./ProfileStyle.vue?vue&type=style&index=0&id=39964182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39964182",
  null
  
)

export default component.exports